import React from "react"
import PropTypes from "prop-types"

import { ConnectedRoute as Route } from "../../lib/connectedRouting"
import Footer from "../../components/Footer/"
import AssetAlertsList from "../../components/AssetAlertsList"
import routes from "../../routes"

import "./AlertsView.scss"

const AlertsView = props => {
  return (
    <div className="alerts-view-container">
      <Route
        path={routes.alerts}
        exact
        render={() => (
          <AssetAlertsList facilityId={props.match.params.facilityId} />
        )}
      />
      <Footer />
    </div>
  )
}

AlertsView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      facilityId: PropTypes.string.isRequired,
      assetAlertId: PropTypes.string,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  deviceType: PropTypes.string.isRequired,
}

AlertsView.defaultProps = {
  deviceType: "desktop",
}

export default AlertsView
